// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "aeaa219ad3ba66147554bf40d32c78025715c104/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};